const locale = {
  title: "Categories",
  addCategory: "Add Category",
  search: {
    placeholder: "Search by category",
    removeAll: "Remove categories",
    selectAll: "Select all",
    deselectAll: "Deselect all",
  },
  confirmationDelete: {
    title: "Delete Category",
    description:
      "Are you sure you want to delete this category? The products will be moved to the <strong>“Other categories”</strong>.",
    buttonConfirm: "Yes, delete",
    buttonCancel: "No, cancel",
  },
  saveChanges: {
    title: "Unsaved Changes",
    description:
      "Are you sure you want to leave this flow? If you do, all unsaved changes will be lost.",
    buttonSave: "Save and exit",
    buttonExit: "Exit without saving",
  },
  copyMessage: "The link to your category has been copied successfully",
  validations: {
    nameRequired: "The category name is required",
    nameDuplicate: "A category with that name already exists",
  },
  breadcrumb: {
    root: "Category",
    create: "Create category",
    edit: "Edit category",
    addProducts: "Add products",
  },
  mapContent: {
    detailLabel: "Detail",
    InformationLabel: "Category Information",
    productsLabel: "Products",
  },
  form: {
    emptyState: {
      title: "You don't have any products/services created yet",
      description: "Create your first product/service to be able to edit your categories.",
      buttonText: "Create product",
    },
    detail: {
      title: "Detail",
      imageLabel: "Multimedia",
      addMultimedia: "Add multimedia",
      validateErrorSize: "Maximum supported weight: {{size}} MB",
      namePlaceholder: "Write a name",
      nameLabel: "Category name",
      descriptionPlaceholder: "Write a description",
      descriptionLabel: "Description",
    },
    products: {
      title: "Products",
      edit: "Edit",
      emptyState: {
        description:
          "Currently this category does not have any products/services",
        buttonText: "Add product",
      },
      header: {
        title: "All products",
        searchPlaceholder: "Search for product",
      },
    },
    saveButton: "Save",
    deleteButton: "Delete",
    loadingDelete: "Deleting category...",
    successDeleteToast: "The category has been deleted successfully",
    successToast: "The category has been saved successfully",
    updatedToast: "The category has been updated successfully",
    errorToast: "Cannot delete the category.",
    errorSuccessToast: "An error occurred while saving the category",
    errorUpdatedToast: "An error occurred while updating the category",
    errorProducts: "You must add at least one product to the category",
    categoryLoading: "Loading category detail"
  },
};

export default locale;
